<template>
  <div class="title">
    <div class="thin">MEIN</div>
    <div class="thick">DIENSTPLAN</div>
  </div>
</div>
</template>

<script>
    export default {
        name: "titlec"
    }
</script>

<style scoped>
  .title{
    display: inline-block;
    font-size: 70px;
    position: fixed;
    white-space: nowrap;
    color: var(--bg);
    width: 100vw;
    text-align: center;
    left: 0;
    pointer-events: none;
    margin-top: -175px;
    margin-top: -195px;
  }

  .thin{
    display: inline-block;
    width: max-content;
    font-family: DistrictProLight;
    font-family: DistrictProThin;
    letter-spacing: -1px;
  }

  .thick{
    display: inline-block;
    width: max-content;
    font-family: DistrictProBold;
    letter-spacing: 0.9px;
  }
</style>
